module.exports = __webpack_public_path__ + "img/document.2ede8ca5.jpg";